import styled from "styled-components";

export const UserImage = styled.img`
  aspect-ratio: 1/ 1;
  width: 6.5rem;
  object-fit: cover;
  border-radius: 0.5rem;
`;
